import React, {FC} from 'react'

const UnzipIcon: FC<any> = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M19.4889 2.47778L17.9444 0.611111C17.6444 0.233333 17.1889 0 16.6667 0H3.33333C2.81111 0 2.35556 0.233333 2.04444 0.611111L0.511111 2.47778C0.188889 2.85556 0 3.35556 0 3.88889V17.7778C0 19 1 20 2.22222 20H17.7778C19 20 20 19 20 17.7778V3.88889C20 3.35556 19.8111 2.85556 19.4889 2.47778ZM3.6 2.22222H16.4L17.3 3.3H2.71111L3.6 2.22222ZM2.22222 17.7778V5.55556H17.7778V17.7778H2.22222ZM11.6111 7.77778H8.38889V11.1111H5.55556L10 15.5556L14.4444 11.1111H11.6111V7.77778Z'
        fill='#A9A9A9'
      />
    </svg>
  )
}

export default UnzipIcon
